import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_comp_label_list_RowClass } from '../../../dbschema/bl_fi_comp_label_list.model';

export class CompanyLabelListContainerModel extends BaseContainerModel {
  bl_fi_comp_label_list: bl_fi_comp_label_list_RowClass = new bl_fi_comp_label_list_RowClass();
}